import EventBus from '@/plugins/vue-event-bus'
import sio from 'socket.io-client'
import store from './store'

const io = sio(process.env.VUE_APP_SOCKETS_URL, {
  extraHeaders: {
    Authorization: `Bearer ${$cookies.get('__fw_token')}`
  }
})

// Server-emitted events
io.on('who-r-u', function() {
  console.log('websocket asking for verification, sending it')
  io.emit('here-i-am', window.location)
})

io.on('fwEvent', (event) => {
  console.log('received fwEvent', event)
  const {
    type,
    data: { board, feature, user, activity, featureLike, invite, statuses, changelog, link, linkedActivity }
  } = event

  switch (type) {
    case 'boardAdded':
      store.dispatch('boards/receiveNewBoard', board)
      break
    case 'boardDeleted':
      store.dispatch('boards/receiveDeletedBoard', board)
      break
    case 'boardUpdated':
      store.dispatch('boards/receiveUpdatedBoard', board)
      break
    case 'featureAdded':
      store.dispatch('features/receiveNewFeature', feature)
      break
    case 'featureDeleted':
      store.dispatch('features/receiveDeletedFeature', feature)
      break
    case 'featureUnliked':
      store.dispatch('features/receivedUnvoteFeature', { feature, user })
      break
    case 'featureLiked':
      store.dispatch('features/receivedVoteFeature', { feature, user, featureLike })
      break
    case 'featureAssigned':
      store.dispatch('activities/addAssignUpdateReceived', { feature, user, activity })
      break
    case 'featureUnassigned':
      store.dispatch('activities/addAssignUpdateReceived', { feature, user, activity })
      break
    case 'featureStatusChanged':
      store.dispatch('activities/addStatusUpdateReceived', { feature, user, activity })
      break
    case 'featureCommented':
      store.dispatch('activities/postCommentReceived', { activity })
      break
    case 'featureLinked':
      store.dispatch('features/mergeFeatureReceived', { feature, link, activity, linkedActivity, user })
      break
    case 'featureUnlinked':
      store.dispatch('features/unmergeFeatureReceived', { feature, link, activity, linkedActivity, user })
      break
    case 'inviteAccepted':
      store.dispatch('postInviteAcceptedReceived', { user })
      break
    case 'inviteAdded':
      store.dispatch('postInvitesReceived', { invite })
      break
    case 'inviteDeleted':
      store.dispatch('deleteInviteReceived', { invite })
      break
    case 'userUpdated':
      store.dispatch('user/updateUserReceived', { user })
      break
    case 'statusesUpdated':
      store.dispatch('postStatusesReceived', { statuses })
      break
    case 'changelogAdded':
      store.dispatch('changelogs/postChangelogReceived', { changelog })
      break
    case 'featureMoved':
      store.dispatch('features/updateBoardReceived', { feature, board })
      break
    case 'featureUpdated':
      store.dispatch('features/receiveUpdateFeature', feature)
      break
    /** Unimplemented but available */
    /*
      case 'companyUpdated':
      case 'integrationAdded':
      case 'integrationDeleted':
      case 'subscriptionAdded':
      case 'subscriptionCancelled':
      case 'changelogDeleted':
      case 'changelogUpdated':
      case 'tagAdded':
      case 'tagDeleted':
      case 'tagUpdated':
    */
    default:
      console.log(`no handler for ${type}`)
  }
})

// Client-emitted events
/*EventBus.$on('some-event', data => {
  console.log('some-event: ', data)
  io.emit('some-event', data)
})*/

EventBus.$on('auth:signin', (user) => {
  io.emit('subscribe-user', user._id)
})

EventBus.$on('auth:signout', () => {
  io.emit('logout')
})

export default io
